// extracted by mini-css-extract-plugin
export default {"selector_container":"styles_selector_container__26JAb","box_container":"styles_box_container__Qm0zu"};